/* PureEthical - aviso a quem esta' num pais para onde nao enviamos.

   PORQUE EXISTE:
   nos primeiros seis meses, 60 das 88 pessoas que chegaram ao
   pagamento vieram da SUICA - um pais para onde o fornecedor nao
   envia e que, por isso, nao e' mercado da loja nem tem zona de
   portes. O site tratava-os bem ate ao fim: o pe-geo.js ate lhes
   traduzia a pagina para frances. Navegavam, punham no cesto, e so'
   no checkout e' que ficavam sem metodo de envio nenhum. Ninguem lhes
   dizia nada.

   Este aviso diz-lhes ao chegar, nao no fim.

   COMO SABE O PAIS:
   pelo mesmo sitio que o pe-geo.js - o /browsing_context_suggestions
   .json da Shopify, que devolve o pais deduzido do IP. Guarda-se o
   resultado num cookie proprio (pe_cc) porque o pe-geo.js corre uma
   unica vez por visitante e marca-se a si proprio como feito; nao se
   pode contar com ele numa segunda visita.

   A LISTA de paises para onde enviamos e' a Uniao Europeia, que e'
   exactamente o que esta' nas zonas de portes da loja. Se um dia o
   o fornecedor passar a enviar para mais lado nenhum - ou para mais
   algum - e' esta lista que tem de mudar, E a zona de portes. As duas
   ao mesmo tempo, senao voltam a divergir.

   Nao bloqueia nada: a pessoa pode continuar a ver a loja. So' deixa
   de ser apanhada de surpresa. Fecha-se e nao volta a aparecer.
*/
(function () {
  var ENVIA = ['AT','BE','BG','CY','CZ','DE','DK','EE','ES','FI','FR','GR','HR',
               'HU','IE','IT','LT','LU','LV','MT','NL','PL','PT','RO','SE','SI','SK'];

  var TXT = {
    'pt': ['De momento não enviamos para {p}.', 'Entregamos apenas na União Europeia.'],
    'en': ['We do not currently ship to {p}.', 'We deliver within the European Union only.'],
    'fr': ['Nous ne livrons pas en {p} pour le moment.', 'Nous livrons uniquement dans l\'Union européenne.'],
    'de': ['Wir liefern derzeit nicht nach {p}.', 'Wir liefern nur innerhalb der Europäischen Union.'],
    'es': ['De momento no enviamos a {p}.', 'Solo entregamos en la Unión Europea.'],
    'it': ['Al momento non spediamo in {p}.', 'Consegniamo solo nell\'Unione Europea.']
  };

  var NOME = {
    'CH':{pt:'a Suíça',en:'Switzerland',fr:'Suisse',de:'die Schweiz',es:'Suiza',it:'Svizzera'},
    'GB':{pt:'o Reino Unido',en:'the United Kingdom',fr:'Royaume-Uni',de:'Großbritannien',es:'el Reino Unido',it:'Regno Unito'},
    'US':{pt:'os Estados Unidos',en:'the United States',fr:'États-Unis',de:'die USA',es:'Estados Unidos',it:'Stati Uniti'},
    'NO':{pt:'a Noruega',en:'Norway',fr:'Norvège',de:'Norwegen',es:'Noruega',it:'Norvegia'},
    'BR':{pt:'o Brasil',en:'Brazil',fr:'Brésil',de:'Brasilien',es:'Brasil',it:'Brasile'},
    'CA':{pt:'o Canadá',en:'Canada',fr:'Canada',de:'Kanada',es:'Canadá',it:'Canada'}
  };

  function lang() {
    var l = (window._PE_LANG || document.documentElement.lang || 'pt');
    l = String(l).toLowerCase().split('-')[0];
    return TXT[l] ? l : 'en';
  }
  function cookieGet(n) {
    var c = String(document.cookie || '').split(/;\s*/);
    for (var i = 0; i < c.length; i++) {
      if (c[i].indexOf(n + '=') === 0) return decodeURIComponent(c[i].slice(n.length + 1));
    }
    return '';
  }
  function cookieSet(n, v, dias) {
    var e = new Date();
    e.setTime(e.getTime() + dias * 864e5);
    document.cookie = n + '=' + encodeURIComponent(v) + ';path=/;expires=' + e.toUTCString() + ';SameSite=Lax';
  }

  if (cookieGet('pe_ship_ok')) return;                  /* ja' fechou o aviso */
  if (window.Shopify && window.Shopify.designMode) return;

  function mostrar(cc) {
    if (!cc || ENVIA.indexOf(cc) > -1) return;
    if (document.getElementById('peShipNotice')) return;

    var l = lang();
    var nome = (NOME[cc] && NOME[cc][l]) || cc;
    var t = TXT[l];

    var bar = document.createElement('div');
    bar.id = 'peShipNotice';
    bar.setAttribute('role', 'status');

    var txt = document.createElement('span');
    txt.className = 'pe-sn-txt';
    var forte = document.createElement('strong');
    forte.textContent = t[0].replace('{p}', nome);
    txt.appendChild(forte);
    txt.appendChild(document.createTextNode(' ' + t[1]));

    var x = document.createElement('button');
    x.type = 'button';
    x.className = 'pe-sn-x';
    x.setAttribute('aria-label', 'Fechar');
    x.textContent = '×';
    x.addEventListener('click', function () {
      cookieSet('pe_ship_ok', '1', 30);
      if (bar.parentNode) bar.parentNode.removeChild(bar);
    });

    bar.appendChild(txt);
    bar.appendChild(x);

    /* logo a seguir a barra de mensagens, antes do cabecalho */
    var ann = document.querySelector('.ann-bar');
    if (ann && ann.parentNode) ann.parentNode.insertBefore(bar, ann.nextSibling);
    else document.body.insertBefore(bar, document.body.firstChild);
  }

  var guardado = cookieGet('pe_cc');
  if (guardado) { mostrar(guardado.toUpperCase()); return; }

  fetch('/browsing_context_suggestions.json?country[enabled]=true', {
    headers: { Accept: 'application/json' },
    credentials: 'same-origin'
  })
    .then(function (r) { return r.ok ? r.json() : null; })
    .then(function (j) {
      if (!j) return;
      var d = j.detected_values || j;
      var c = d && d.country && (d.country.handle || d.country.iso_code || d.country.code);
      if (!c) return;
      c = String(c).toUpperCase();
      cookieSet('pe_cc', c, 30);
      mostrar(c);
    })
    .catch(function () {});
})();
